import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CustomInputEditor } from '../custom-inputEditor';
import { Formatters, OnEventArgs } from 'angular-slickgrid';
@Component({
    selector: 'app-auto-closure-master',
    templateUrl: './auto-closure-master.component.html',
    styleUrls: ['./auto-closure-master.component.css']
})
export class AutoClosureMasterComponent implements OnInit, OnDestroy {

    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    time: string;


    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private clientId: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    radioChecked: number;
    ttypes = [];
    ticketSelected: number;
    ticketType: string;
    dataLoaded: boolean;

    awatingTime: string;
    awatingCalTypedesc: number;
    spocChecked = false;
    isSpocChange: boolean;
    awatingCalType: string;

    awatingCalTypes = [{ id: 0, awatingCalType: 'Calculation Type', awatingCalTypeDesc: 'Calculation Type' },
    { id: 1, awatingCalType: 'B', awatingCalTypeDesc: 'Business Hours' },
    { id: 2, awatingCalType: 'C', awatingCalTypeDesc: 'Callender Hours' }];
    selectedId: any;
    private modalReference: NgbModalRef;
    @ViewChild('content1') private content1;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            console.log("gggggggggg " + item.ticket_closure_time);
                            item.createdBy = this.messageService.getUserId();
                            if (item.ticket_closure_time > 0 || item.ticket_aur_closure_time > 0) {
                                this._rest.updateTicketAutoClosureTime(item).subscribe((res) => {
                                    this.respObject = res;
                                    if (this.respObject.success) {
                                        // console.log('data--Done');
                                        this.notifier.notify('success', 'Updated successfully');
                                        this.getTableData();
                                    } else {
                                        // console.log('data--Not---Done');
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    this.notifier.notify('error', JSON.stringify(err));
                                });
                            }
                            else {
                                console.log('fffffffffffffffffffffff');
                                this.notifier.notify('error', 'Ticket closure time should be an integer');

                            };
                        }
                    }
                    break;
                case 'delete':
                    console.log("gggggggggg " + item.ticket_closure_time);
                    item.createdBy = this.messageService.getUserId();
                    item.isDelete = true;
                    this._rest.updateTicketAutoClosureTime(item).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            // console.log('data--Done');
                            this.notifier.notify('success', 'Updated successfully');
                            this.getTableData();
                        } else {
                            // console.log('data--Not---Done');
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.notifier.notify('error', JSON.stringify(err));
                    });
                    break;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.isSpocChange = false;
        this.time = '';
        this.awatingTime = '0';
        this.awatingCalType = '0';
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: ' Maintain Auto Closure',
            openModalButton: ' Add Auto Closure',
            breadcrumb: 'Auto Closure',
            folderName: 'Auto Closure',
            tabName: 'Auto Closure'
        };
        const columnDefinitions = [
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true, width: 20},
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
            },
            {
                id: 'closureTime', name: 'Ticket Closure Time (After Resolved)', field: 'ticket_closure_time', sortable: true, cssClass: 'highlight', filterable: true, editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'ticket_aur_closure_time', name: 'Awaiting Ticket Closure Time', field: 'ticket_aur_closure_time', sortable: true, cssClass: 'highlight', filterable: true, editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'ticket_closure_calculation_type_aur', name: 'Awaiting Ticket Closure Calculation Type', field: 'ticket_closure_calculation_type_aur', sortable: true,
                cssClass: 'highlight', filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.awatingCalType = '';
        this.getTableData();
    }

    spocChange() {
        this.isSpocChange = !this.isSpocChange;
        this.spocChecked = !this.spocChecked;
        console.log('spocChecked === >>>  ' + this.spocChecked);
    }

    onawatingCalTypeChange(val) {
        this.awatingCalType = this.awatingCalTypes[val].awatingCalType;
        console.log('this.awatingCalType == >>> ' + this.awatingCalType);
    }


    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.isSpocChange = false;
            this.awatingCalTypedesc = 0;
            this.modalService.open(content, { size: 'sm' }).result.then((result) => {
            }, (reason) => {
            });
        }
    }

    save() {
        const data = {
            clientId: this.clientId,
            ticket_closure_time: Number(this.time),
            createdBy: this.messageService.getUserId(),
            ticket_type: this.ticketSelected
        };
        if (data.ticket_closure_time > 0) {
            if (!this.messageService.isBlankField(data)) {
                console.log(JSON.stringify(data));
                if (this.isSpocChange && (this.awatingTime !== '0' && this.awatingCalType !== '0')) {
                    data['awatingTime'] = this.awatingTime;
                    data['awatingCalType'] = this.awatingCalType;
                }
                this._rest.insertTicketAutoClosureTime(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        const id = this.respObject.details;
                        this.getTableData();
                        this.time = '';
                        this.awatingTime = '0';
                        this.awatingCalType = '';
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
            }
        }
        else {
            console.log('.......................................');
            this.notifier.notify('error', 'Ticket closure time should be an integer');
        }
    }

    update() {

    }



    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getTicketAutoClosureTime(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }

    onTicketChange(selectedIndex: any) {
        this.ticketType = this.ttypes[selectedIndex].name;
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
